import { motion } from "framer-motion";
import { useFactors, foundationToStart } from "../state/FactorsContext";
import { scientific } from "../lib/format";
import FoundationControls from "./FoundationControls";
import GlobalControls from "./GlobalControls";

/**
 * The opening act. We set the stage with the crushing starting number — every
 * planet in the observable universe — then expose the foundational inputs and
 * the global controls before the descent begins.
 */
export default function Opening() {
  const { data, foundation } = useFactors();
  const { meta } = data;
  const start = foundationToStart(foundation);

  return (
    <header className="mx-auto max-w-3xl pt-14 text-center sm:pt-20">
      <motion.h1
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="font-display text-4xl font-light tracking-tight text-white sm:text-6xl"
      >
        {meta.title}
      </motion.h1>
      {meta.subtitle && (
        <p className="mt-3 font-display text-lg font-light italic text-cyan/80 sm:text-2xl">
          {meta.subtitle}
        </p>
      )}
      {meta.intro && (
        <p className="mx-auto mt-6 max-w-xl text-sm font-light leading-relaxed text-white/75 sm:text-base">
          {meta.intro}
        </p>
      )}

      {/* The starting number — the vastness we begin from. */}
      <div className="mt-12">
        <p className="text-[11px] uppercase tracking-[0.25em] text-cyan/80">
          We begin with
        </p>
        <p className="mt-2 font-display text-5xl font-light text-white sm:text-7xl">
          {scientific(start)}
        </p>
        <p className="mt-2 text-sm text-white/60">
          {meta.startingLabel ?? "planets"}
        </p>
      </div>

      <div className="mx-auto mt-10 max-w-md text-left">
        <FoundationControls />
      </div>

      {/* On desktop the side panel carries the controls, so only show them
          in-flow on mobile. */}
      <div className="mt-10 lg:hidden">
        <GlobalControls />
      </div>

      <p className="mt-12 animate-pulse text-xs uppercase tracking-[0.3em] text-white/45">
        Scroll to watch it collapse ↓
      </p>
    </header>
  );
}
